import { useCallback, useRef, useState } from 'react';
import { INDICATORS } from '../helpers/indicatorConfig';

export function useIndicators(chartI) {
  const [activeIndicators, setActiveIndicators] = useState({});
  const activeRef = useRef(activeIndicators);
  activeRef.current = activeIndicators;

  const addIndicator = useCallback(async (type) => {
    if (!chartI) return;
    const config = INDICATORS[type]; if (!config) return;
    const uuid = `${type}_${Date.now()}`;
    const params = { ...config.defaultParams, indexIndicator: uuid };
    try {
      const result = await chartI.createIndicator(type, params);
      if (result?.index == null && result?.index !== 0) return;
      setActiveIndicators(prev => ({
        ...prev,
        [uuid]: { uuid, type, chartIndex:result.index, title:result.title??config.fullLabel, params:{...config.defaultParams}, visible:true },
      }));
    } catch(err) { console.error('[useIndicators] addIndicator:', err?.message); }
  }, [chartI]);

  const updateIndicator = useCallback(async (uuid, newParams) => {
    if (!chartI) return;
    const entry = activeRef.current[uuid]; if (!entry) return;
    const merged = { ...entry.params, ...newParams };
    try {
      const fn = { EMA:()=>chartI.changeEMA(entry.chartIndex,merged), SMA:()=>chartI.changeSMA(entry.chartIndex,merged),
        BBANDS:()=>chartI.changeBBANDS(entry.chartIndex,merged), MACD:()=>chartI.changeMACD(entry.chartIndex,merged),
        SO:()=>chartI.changeSO(entry.chartIndex,merged), RSI:()=>chartI.changeRSI(entry.chartIndex,merged),
        CCI:()=>chartI.changeCCI(entry.chartIndex,merged), ROC:()=>chartI.changeROC(entry.chartIndex,merged),
        ADX:()=>chartI.changeADX(entry.chartIndex,merged) }[entry.type];
      await fn?.();
      setActiveIndicators(prev => ({ ...prev, [uuid]: { ...prev[uuid], params:merged } }));
    } catch(err) { console.error('[useIndicators] updateIndicator:', err?.message); }
  }, [chartI]);

  const toggleVisibility = useCallback(async (uuid) => {
    if (!chartI) return;
    const entry = activeRef.current[uuid]; if (!entry) return;
    try {
      await chartI.removeIndicator(entry.chartIndex, entry.type, false);
      setActiveIndicators(prev => ({ ...prev, [uuid]: { ...prev[uuid], visible:!prev[uuid].visible } }));
    } catch(err) {}
  }, [chartI]);

  const removeIndicator = useCallback(async (uuid) => {
    if (!chartI) return;
    const entry = activeRef.current[uuid]; if (!entry) return;
    try {
      await chartI.removeIndicator(entry.chartIndex, entry.type, true);
      setActiveIndicators(prev => { const next={...prev}; delete next[uuid]; return next; });
    } catch(err) {}
  }, [chartI]);

  const removeAllIndicators = useCallback(async () => {
    if (!chartI) return;
    for (const entry of Object.values(activeRef.current)) {
      try { await chartI.removeIndicator(entry.chartIndex, entry.type, true); await new Promise(r=>setTimeout(r,80)); } catch(e) {}
    }
    setActiveIndicators({});
  }, [chartI]);

  const resetIndicators = useCallback(() => setActiveIndicators({}), []);

  return {
    activeIndicators,
    activeList: Object.values(activeIndicators),
    addIndicator, updateIndicator, toggleVisibility, removeIndicator, removeAllIndicators, resetIndicators,
  };
}
